window.vkB2B = window.vkB2B || {};

(function (vkB2B) {
  'use strict';

  vkB2B.initContactSalesDialogs = function () {
    document.querySelectorAll('[data-vk-b2b-contact-dialog]').forEach(function (dialog) {
      if (dialog.dataset.vkB2BInitialized === 'true') return;

      dialog.dataset.vkB2BInitialized = 'true';

      var dialogId = dialog.getAttribute('id');
      var activeTrigger = null;

      var supportsContext = dialog.hasAttribute('data-vk-b2b-contact-supports-context');
      var contextLine = dialog.querySelector('[data-vk-b2b-quote-context-line]');

      document.querySelectorAll('[data-vk-b2b-contact-trigger]').forEach(function (trigger) {
        if (trigger.getAttribute('aria-controls') !== dialogId) return;

        trigger.addEventListener('click', function (event) {
          if (typeof dialog.showModal !== 'function') return;

          event.preventDefault();
          activeTrigger = event.currentTarget;

          if (supportsContext && contextLine) {
            var context = trigger.getAttribute('data-vk-b2b-quote-context') || '';
            contextLine.hidden = !context;
            contextLine.textContent = context ? 'Regarding: ' + context : '';
          }

          dialog.showModal();
        });
      });

      dialog.querySelectorAll('[data-vk-b2b-contact-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          dialog.close();
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      dialog.addEventListener('close', function () {
        if (activeTrigger) {
          window.requestAnimationFrame(function () {
            activeTrigger.focus();
            activeTrigger = null;
          });
        }
      });

      dialog.querySelectorAll('[data-vk-b2b-copy-email]').forEach(function (button) {
        button.addEventListener('click', function () {
          var email = button.getAttribute('data-vk-b2b-copy-email-value') || '';
          var status = dialog.querySelector('[data-vk-b2b-copy-status]');

          if (!email || !status) return;

          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(email).then(function () {
              status.textContent = 'Email address copied.';
            }).catch(function () {
              status.textContent = 'Copy the email address shown above.';
            });
          } else {
            status.textContent = 'Copy the email address shown above.';
          }
        });
      });
    });
  };

  vkB2B.initWholesaleAccountDialogs = function () {
    document.querySelectorAll('[data-vk-b2b-account-dialog]').forEach(function (dialog) {
      if (dialog.dataset.vkB2BInitialized === 'true') return;

      dialog.dataset.vkB2BInitialized = 'true';

      var returnTarget = document.querySelector('.vk-b2b-hero__actions a');
      var closeButton = dialog.querySelector('[data-vk-b2b-account-dialog-close]');

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        });
      }

      dialog.addEventListener('close', function () {
        if (!returnTarget) return;

        window.requestAnimationFrame(function () {
          returnTarget.focus();
        });
      });

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      if (closeButton) {
        window.requestAnimationFrame(function () {
          closeButton.focus();
        });
      }
    });
  };

  vkB2B.initWholesaleStatePages = function () {
    if (!document.querySelector('[data-vk-b2b-state-page]')) return;

    document.querySelectorAll(
      '.vk-b2b-hero, .vk-b2b-benefits, .vk-b2b-process, .vk-b2b-faq, .vk-b2b-cta'
    ).forEach(function (section) {
      section.hidden = true;
    });
  };

  vkB2B.initWholesaleSubmissionState = function () {
    var successState = document.querySelector('[data-vk-b2b-application-success]');
    if (!successState) return;

    document.querySelectorAll(
      '.vk-b2b-state, .vk-b2b-hero, .vk-b2b-benefits, .vk-b2b-process, .vk-b2b-faq, .vk-b2b-cta'
    ).forEach(function (section) {
      if (!section.contains(successState)) section.hidden = true;
    });
  };

  vkB2B.initWholesalePage = function () {
    vkB2B.initContactSalesDialogs();
    vkB2B.initWholesaleAccountDialogs();
    vkB2B.initWholesaleStatePages();
    vkB2B.initWholesaleSubmissionState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vkB2B.initWholesalePage);
  } else {
    vkB2B.initWholesalePage();
  }
})(window.vkB2B);
